import React, {useEffect, useState} from "react";
import {LineAfterStatistic} from "../../assets/icons";

import CountUp from "react-countup";
import apiService from "../../services/apiService";
import {useLanguage} from "../../hooks/LanguageContext";

const Statistic = () => {
	const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL; // Access the base URL
	const { direction } = useLanguage();
	const [isVisible, setIsVisible] = useState(false);
	const [data, setData] = useState([]);

	useEffect(() => {
		apiService
			.getCompanyStats()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {
				// Handle errors here
			});
	}, []);

	useEffect(() => {
		// Create intersection observer
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setIsVisible(true);
					}
				});
			},
			{ threshold: 0.1 }
		);

		// Get the element to observe
		const element = document.getElementById("statistic");
		if (element) {
			observer.observe(element);
		}

		return () => {
			if (element) {
				observer.unobserve(element);
			}
		};
	}, []);

	return (
		<section id="statistic" className="container pb-[60px] md:pb-[130px]">
			<div
				className={`grid ${
					data.length > 0 ? `md:grid-cols-${data.length}` : ""
				} grid-cols-2 gap-4 md:gap-12 w-full mx-auto place-items-center`}
			>
				{data.map((item) => (
					<div
						className="w-full h-full flex flex-col justify-between items-center"
						key={item.id}
					>
						{/* Icon */}
						<div className="flex-shrink-0 h-[100px] w-[100px] flex justify-center items-center">
							<img
								className="h-[80px] w-[80px] object-contain"
								src={`${baseUrl}/${item.icon}`}
								alt={item.title_en + " icon"}
							/>
						</div>

						{/* Count */}
						<h2 className="headline-2-ar text-center text-primary-700">
							<CountUp
								start={0}
								end={isVisible ? item.count : 0}
								duration={2.5}
								separator=","
							/>
							{item.count > 10 && `+`}
						</h2>

						{/* Title */}
						<p className="text-balance leading-[23.52px] font-medium text-center text-grayscale-500">
							{direction === "rtl" ? item.title_ar : item.title_en}
						</p>

						{/* Decorative Line */}
						<LineAfterStatistic />
					</div>
				))}
			</div>
		</section>
	);
};

export default Statistic;
